import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../../LinkyLinky';
import { Link } from '../../../../../../../../Resource/Types';
import Modal from '../../../../../../../Modal';
import InviteParticipantStore from '../../Store';
import { SelectParticipantsState } from '../../Types';
import Body from './Body';
import Header from './Header';

export interface Props {
  store: InviteParticipantStore;
  links: ReadonlyArray<Link>;
  state: SelectParticipantsState;
}

function ReadyModal({ store, links, state }: Props) {
  return findLink('options', links)
    .map((link) => (
      <Modal
        close={store.modalStore.close}
        title={<Header />}
        customBackgroundCssClasses="bg-teal-100 opacity-60"
        modalWidth="w-2/5"
      >
        <Body link={link} store={store} state={state} />
      </Modal>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ReadyModal);
